import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoadingScreenComponent {}
